import { render, staticRenderFns } from "./PortalDocuments.vue?vue&type=template&id=29a269fd&scoped=true&"
import script from "./PortalDocuments.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortalDocuments.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PortalDocuments.vue?vue&type=style&index=0&id=29a269fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a269fd",
  null
  
)

export default component.exports